import MoreIcon from '@/assets/images/common/svg/more.svg?react';
import styles from '../../index.module.scss';
import GroupMemberList from '../../../group-member-list';
import AddIcon from '../../images/add.svg?react';
import SubIcon from '../../images/sub.svg?react';
import classes from './index.module.scss';
import type { GroupSettingMembersProps } from './interface';

export default function GroupSettingMembers({
  chat,
  user,
  normalMemberList,
  showManager,
  handSearchMembers,
  handAddMembers,
  handDeleteMembers,
  closeSettings,
}: GroupSettingMembersProps) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader} onClick={handSearchMembers}>
        <div className={styles.membersNum}>{normalMemberList?.length} members</div>
        <MoreIcon className={styles.membersSearch} />
      </div>
      <div className={styles.cardBody}>
        <div className={classes.members}>
          <div className={classes.operation} onClick={handAddMembers}>
            <AddIcon className={classes.operationIcon} />
            <span>Add members</span>
          </div>
          {showManager && (
            <div className={classes.operation} onClick={handDeleteMembers}>
              <SubIcon className={classes.operationIcon} />
              <span>Deleted members</span>
            </div>
          )}
          <GroupMemberList
            chat={chat}
            user={user}
            memberList={normalMemberList?.slice(0, 3)}
            onClick={closeSettings}
          />
        </div>
      </div>
    </div>
  );
}
